import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
} from '@angular/core';
import type { FeaturedPartnerV2 } from '@rd/types';
import { MarkdownModule } from 'ngx-markdown';
import { BnzLinkModule } from '../../../../shared/components/link/link.module';

@Component({
  selector: 'bnz-featured-partner-v2-banner',
  template: `
    <div class="static-page-link-image flex items-center w-full">
      <picture class="w-full">
        <source
          media="(max-width: 1023px)"
          [srcset]="banner.mobileImage" />
        <img
          class="static-page-link-image h-[160px] lg:h-[250px] w-full rounded-md object-cover"
          [src]="banner.desktopImage"
          alt="" />
      </picture>
    </div>

    <div class="flex flex-col">
      <h3 class="m-0 -mb-1 text-2xl font-bold leading-[30px] text-[#002f6b] line-clamp-2">
        {{ banner.title }}
      </h3>
      <markdown
        ngPreserveWhitespaces
        class="typo-text-mobile m-0 text-[#002f6b] line-clamp-5">
        {{ banner.description }}
      </markdown>
      <bnz-shared-link
        contentClass="line-clamp-1"
        class="mt-2 block font-bold lg:mt-5 leading-[19px]"
        [showIcon]="false"
        [text]="banner.ctaText"
        [path]="banner.ctaUrl" />
    </div>
  `,
  imports: [CommonModule, BnzLinkModule, MarkdownModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BnzFeaturedPartnerV2BannerComponent {
  @HostBinding('class') hostClass =
    'lg:grid gap-5 lg:grid-cols-2 lg:gap-6 items-start lg:items-center flex flex-col';
  @Input() banner: FeaturedPartnerV2;
}
